
























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'

import EditMarques from  '@/components/profilExclusion/edit/EditMarques.vue'
import CheckState from '@/components/shared/CheckState.vue'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import { TypeOffre } from '@/enum/TypeOffre'
import { getDefaultAloBase } from '@/models/alo/AloBase'
import { toNumberDictionary, chunk } from '../../../utils/groupBy'

@Component({
  name: 'ReadMarques',    
  components:{CheckState,EditMarques},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    profilExclusion:{
      type:Object,
      default:getDefaultAloProfilExclusion()
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadMarques extends Vue {
  
  private profilExclusion!:AloProfilExclusion
  private loading!:boolean

  private headersMarque = [
    { text: 'Marques exclues', value: 'libelle'  }
  ]

  edit() {     
    (this.$refs.editMarques as EditMarques).edit(this.profilExclusion)
  }

  get totalMarques(){
    return this.$store.myGetters.marquesList.length
  }

  created(){
    this.$store.myActions.CATALOGUE_MARQUE_ENSURE()
  }

  get marquesList(){    
    return this.$store.myGetters.marquesList
  }

  get showInclue(){
    return this.profilExclusion.mrqIds.length > (this.marquesList.length / 2)
  }

  get inclueOrExclueTitle(){
    return this.showInclue?"Marques inclues :":"Marques exclues :"
  }

  get marquesToShow(){    
    return this.showInclue?
        this.marquesList.filter(m => !this.dicExcludedMarque[m.id])
      : this.marquesList.filter(m => !!this.dicExcludedMarque[m.id])
  }

  get sizeGrp(){
    //@ts-ignore
    if(this.$vuetify.breakpoint.xl) return 6
    //@ts-ignore
    else if(this.$vuetify.breakpoint.lg) return 4
    //@ts-ignore
    else if(this.$vuetify.breakpoint.md) return 3
    else return  2;
  }


  get marquesToShowByGroup(){
    return chunk(this.marquesToShow,this.sizeGrp).map(it => {return {id:it[0].id, marques:it}})
  }

  get dicExcludedMarque(){
    return toNumberDictionary(this.profilExclusion.mrqIds,id => id)
  }

}
